import { render, staticRenderFns } from "./submit_review_button.vue?vue&type=template&id=e651a250"
import script from "./submit_review_button.vue?vue&type=script&lang=js"
export * from "./submit_review_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports